export default function ToggleSwitch({ label, checked, onChange }) {
  return (
    <div className="flex items-center justify-between mb-4">
      <span>{label}</span>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="w-5 h-5 rounded-full accent-indigo-500"
      />
    </div>
  );
}
